module.exports = __webpack_public_path__ + "static/media/IRWIN-Logo-FullColor-RGB.8e54bb3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/IRWIN-Logo-FullColor-RGB.png
// module id = 1024
// module chunks = 0